import type { FC } from 'react'
import type { SxProps, Theme } from '@mui/material'
import { Typography } from '@mui/material'
import type { FormattedAgentActivity, FormattedUserActivity } from '../utils'

interface UserActivityContentProps {
  readonly activity: FormattedAgentActivity | FormattedUserActivity
}

export const UserActivityContent: FC<UserActivityContentProps> = ({ activity }) => (
  <Typography sx={userContextSx}>{activity.activityContext}</Typography>
)

const userContextSx: SxProps<Theme> = {
  fontSize: '0.75rem',
  color: 'text.secondary',
  fontStyle: 'italic',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}
